<template>
  <div>
    <b-form-group
        :label="$t('message.Name_uz')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="places.name_uz"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_ru')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="places.name_ru"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_en')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="places.name_en"
          required
      />
    </b-form-group>
    <b-form-group
        :label="$t('message.Name_kr')"
        label-for="name-input"
        invalid-feedback="Name is required"
    >
      <b-form-input
          id="name-input"
          v-model="places.name_kz"
          required
      />
    </b-form-group>
    <div
        style="margin-top: 30px; margin-left: 150px">
      <b-button
          variant="outline-primary"
          @click="handleClick"
      >{{$t('message.Cancel')}}
      </b-button>
      <b-button
          @click="handleSubmit"
          style="margin-left: 10px"
          variant="primary"
      >{{$t('message.Add')}}
      </b-button>
    </div>
  </div>
</template>

<script>

import {addPlaces, editPlaces, getPlacesById} from "../../../../../../api/work-places";

export default {
  name: "PlacesModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      places: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchPlaces(){
      getPlacesById({ id: this.id}).then(response => {
        this.places = response.data.data
      })
    },
    handleSubmit() {
      if (this.places.name_uz
          && this.places.name_ru
          && this.places.name_en
          && this.places.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editPlaces(this.places).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addPlaces(this.places).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchPlaces()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




